import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { AppService } from "@App";
import { IConfigService } from "@Config";
import { InterviewSectionDTO, InterviewSectionSummaryDTO, SectionDTO } from "@DTOs";
import { SectionProgress } from "@Models";
import { BaseService } from "@Services/base.service";
import { ObservableService } from "@Services/observable.service";
import { Observable, ReplaySubject } from "rxjs";
import { SubSink } from "subsink";

@Injectable({
    providedIn: 'root'
})
export default class InterviewProgressService extends BaseService implements OnDestroy {

    subs = new SubSink();
    publicApiBaseUrl: string;

    public sections: SectionProgress[];
    constructor(
        public configService: IConfigService,
        public httpClient: HttpClient,
        public appService: AppService,
        public observableService: ObservableService
    ) {
        super(appService, configService, httpClient);
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    public getApplicationProgress(accountId: string, versionNumber, caseId: string = null) : Observable<SectionProgress[]> {
        const clientId = this.appService.getClientId('');
        let url = `${this.publicApiBaseUrl}client/${clientId}/account/${accountId}/${versionNumber}/applicationProgress`;

        if (caseId !== null){
            url+= `/${caseId}`;
        }

        return super.getData(url, null, true);
    }

    public getSectionCount() : number{
        return this.sections.length;
    }

    public updateQuestion(sectionId, questionId, isHidden = false, isAnswered = false){
        const section = this.sections.find(x => x.sectionId === sectionId);

        if (!section) {
            return;
        }

        const question = section.questions.find(x => x.questionId === questionId);
        question.isHidden = isHidden;
        question.isAnswered = isAnswered;
    }

    public updateSection(sectionDto: InterviewSectionDTO, visibleSections: InterviewSectionSummaryDTO[]){
        const section = this.sections.find(x => x.sectionId === sectionDto.id);

        if (!section) {
            return;
        }

        section.questions.forEach(question => {
            const questionDto = sectionDto.questions.find(x => x.id === question.questionId);

            question.isHidden = !questionDto.display || questionDto.answerType === 'DisplayMessage' ? true : false;
            question.isAnswered = questionDto.answerValue && questionDto.answerValue !== '' ? true : false;
        });
        section.isHidden = !sectionDto.display;

        this.calculateSectionProgress(section);

        this.sections.forEach(section => {
            const visibleSection = visibleSections.find(x => x.id === section.sectionId);

            if (!visibleSection) {
                section.isHidden = true;
            }
        });
    }

    public calculateSectionProgress(section: SectionProgress){
        const remainingQuestions = section.questions.filter(x => x.isAnswered === false && x.isHidden === false);
        const totalQuestions = section.questions.filter(x => x.isHidden === false);

        section.progress = ((totalQuestions.length - remainingQuestions.length) / totalQuestions.length ) * 100 ;
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}